import React from "react";
import { SpecialtyDetailFootnote } from "@app/projects/results/adequacy";

interface NetworkCoverageMapCountyDetailInfoProps {
  info: SpecialtyDetailFootnote;
  cmsCreditIsApplying: boolean;
  minProvidersFromRatio?: number | null;
}

// If updating the wording of this component, consider also updating AdequacyDetailInfoTemplate.tsx as the wording is the same, but styling is different.
const NetworkCoverageMapCountyDetailInfo: React.FC<NetworkCoverageMapCountyDetailInfoProps> = ({ info, cmsCreditIsApplying, minProvidersFromRatio }) => {
  if (!info) {
    return <></>;
  }

  const isPendingCounty = info.geographyStatus === "Pending" && info.geographyType === "county";
  const passPercentage = cmsCreditIsApplying && isPendingCounty ? info?.passPercentageWithCMSAppCreditPercentage : info?.passPercentage;

  const providerRegionTypePhrase = info.providerRegionTypePhrase !== "" ? (
    <>
      <strong> {minProvidersFromRatio ?? info.requiredServicingCount} {info.specialtyGroupName} {info.servicingEntityType}</strong> {info.providerRegionTypePhrase}
    </>
  ) : <></>;

  const templateCriteriaBody = info.skipAccessTimeAndDistance ? (
    <> {info.geographyType} where networks are required to have
      {providerRegionTypePhrase}.
    </>
  ) : (
    <> {info.geographyType} where networks are required to cover {passPercentage}% of the beneficiaries with access to
      <strong> {info.minimumProviderCount} {info.specialtyGroupName} {info.entityType}</strong> within
      <strong><span> {info.minimumDistancePhrase}</span></strong>{info.accessOverride ? " (access customization)" : ""}
      {info.providerRegionTypePhrase !== "" ? " and " : ""}
      {providerRegionTypePhrase}.
    </>
  );

  return (
    <div>
      <h4 className="header-s">
        {info.geographyName}
      </h4>
      <span>{info.geographyClass ? ` ${info.geographyClass}` : ""}</span>
      {templateCriteriaBody}
    </div>
  );
};

export default NetworkCoverageMapCountyDetailInfo;
